/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { SaveWrapper } from "../SaveWrapper";

export class SaveWrapper__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _save: string,
    _vault: string,
    _mAsset: string,
    _bAssets: string[],
    _uniswapAddress: string,
    overrides?: Overrides
  ): Promise<SaveWrapper> {
    return super.deploy(
      _save,
      _vault,
      _mAsset,
      _bAssets,
      _uniswapAddress,
      overrides || {}
    ) as Promise<SaveWrapper>;
  }
  getDeployTransaction(
    _save: string,
    _vault: string,
    _mAsset: string,
    _bAssets: string[],
    _uniswapAddress: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      _save,
      _vault,
      _mAsset,
      _bAssets,
      _uniswapAddress,
      overrides || {}
    );
  }
  attach(address: string): SaveWrapper {
    return super.attach(address) as SaveWrapper;
  }
  connect(signer: Signer): SaveWrapper__factory {
    return super.connect(signer) as SaveWrapper__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SaveWrapper {
    return new Contract(address, _abi, signerOrProvider) as SaveWrapper;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_save",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_mAsset",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_bAssets",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "_uniswapAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_ethAmount",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "_path",
        type: "address[]",
      },
    ],
    name: "estimate_saveViaUniswapETH",
    outputs: [
      {
        internalType: "uint256",
        name: "out",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mAsset",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "save",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "saveAndStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bAsset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amt",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minOut",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_stake",
        type: "bool",
      },
    ],
    name: "saveViaMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amountOutMin",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "_path",
        type: "address[]",
      },
      {
        internalType: "uint256",
        name: "_minOutMStable",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_stake",
        type: "bool",
      },
    ],
    name: "saveViaUniswapETH",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "uniswap",
    outputs: [
      {
        internalType: "contract IUniswapV2Router02",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "vault",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
